const dropdownStyles = {
    option: (defaultStyles, state) => ({
        ...defaultStyles,
        color: '#000',
        backgroundColor: state.isSelected ? '#DFDFDF' : '#FFF',
        '&:hover': {
            backgroundColor: '#DFDFDF',
        },
        cursor: 'pointer'
    }),

    control: (defaultStyles, state) => ({
        ...defaultStyles,
        minHeight: 40,
        paddingVertical: 6,
        paddingHorizontal: 12,
        border: state.isFocused ? '2px solid #007EB4' : state.isDisabled ? '1px solid rgba(117, 117, 117, 0.5)' : '1px solid #767676',
        backgroundColor: null,
        boxShadow: state.isFocused ? '#007EB4' : 'none',
        '&:hover': {
            border: '2px solid #007EB4',
            boxShadow: '#007EB4',
            cursor: 'pointer'
        }
    }),

    indicatorSeparator: (defaultStyles) => ({
        ...defaultStyles,
        display: 'none'
    }),

    dropdownIndicator: (defaultStyles, state) => ({
        ...defaultStyles,
        color: state.isDisabled ? 'rgba(117, 117, 117, 0.5)' : '#767676',
        '&:hover': {
            color: '#767676'
        }
    }),

    singleValue: (defaultStyles, state) => ({ ...defaultStyles, color: state.isDisabled ? 'rgba(0, 0, 0, 0.50)' : '#000' }),

    multiValue: (defaultStyles) => ({
        ...defaultStyles,
        backgroundColor: '#007EB4',
        color: 'white',
        borderRadius: 4
    }),

    multiValueLabel: (defaultStyles) => ({
        ...defaultStyles,
        color: 'white',
        fontWeight: '600'
    }),

    multiValueRemove: (defaultStyles) => ({
        ...defaultStyles,
        color: 'rgba(255, 255, 255, 0.5)',
        ':hover': {
          color: 'white',
        },
    }),

    clearIndicator: (defaultStyles, state) => state.isMulti ? ({
        ...defaultStyles,
        display: 'none'
    }) : null
}

export default dropdownStyles